import { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Table,
  TableBody,
  // TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  Checkbox,
  IconButton,
  Snackbar,
  CircularProgress,
  Backdrop,
  Popover,
  Tooltip,
  Skeleton,
  Autocomplete,
  MenuItem,
  ListItemText,
  TextField,
  useMediaQuery,
  Stack,
  Fade,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { ClearIcon } from '@mui/x-date-pickers';
import { Link } from 'react-router-dom';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { ArrowCircleRight, CloudDownload, CloudUpload, EditOff, LocalPrintshop, MarkEmailUnread, Share } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { MoreVert, Clear } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import ConfirmDeleteModal from '../../components/modals/ConfirmDeleteModal';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import pdfImage from '../../assets/images/attachments/pdf.png';
import { TableCell } from '../../components/Table/TableCell';

import { listTransactionMasterv2, listTransactionMasterCount, getTransactionMaster } from '../../graphql';
import DeletePaymentEntry from '../../components/modals/DeletePaymentEntry';
import DeleteSelectedPaymentEntry from '../../components/modals/DeleteSelectedPaymentEntry';
import DropDownForListing from '../../components/DropDown/DropDown';
import theme from '../../styles/Themecolors';
import { useWarningModal } from '../../components/modals/AddUnits';
import { cancelTransactionMaster } from '../../graphql/mutations';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import TeaxtareaField from '../../components/formElements/TeaxtareaField';
import LinkList from '../../components/Buttons/linkList';
import { updateTitle, updateViewTitle } from '../../redux/reducers/titleSlice';
import { createDebouncedCallback } from '../../hooks/createDebouncedCallback';
import CustomDate from '../../components/Date/CustomDate';
import dayjs from 'dayjs';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown';
import moment from 'moment';
import {
  checkandopenpdf,
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  fetchAndPrintPDF,
  getDefaultSorting,
  handleFreeze,
} from '../../utils/common';
import { ShareModal } from '../../components/modals/Share';
import { useThemes } from '../../components/Theme/theme';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import useSavePrevent from '../../hooks/useSavePrevent';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';
import { paymentApi } from '../../features/Payment/api/payment.api';
import RollingSoon from '../../components/Ui/RollingSoon';
import { DateRangeRsuite, MoneyTextFieldRange } from '../../components';
import { DEFAULT_DATE_FORMAT } from '../../config';
import { formatUnixTimestamp } from '../../library';

const headCell = [
  {
    id: 'EntryDate',
    numeric: false,
    disablePadding: true,
    label: 'Payment Date',
    width: '100px',
  },
  {
    id: 'VoucherNumber',
    numeric: false,
    disablePadding: false,
    label: 'Voucher No',
    width: '100px',
  },
  {
    id: 'PaidFrom',
    numeric: false,
    disablePadding: false,
    label: 'Paid From (Cr)',
    width: '130px',
  },
  {
    id: 'PaidTo',
    numeric: false,
    disablePadding: false,
    label: 'Paid To (Dr)',
    width: '130px',
  },
  {
    id: 'TransactionTypeCD',
    numeric: false,
    disablePadding: false,
    label: 'Mode',
    width: '50px',
  },
  {
    id: 'paymentamount',
    numeric: true,
    disablePadding: false,
    label: 'Amount (₹)',
    width: '100px',
  },
  {
    id: 'tds_payable_amount',
    numeric: true,
    disablePadding: false,
    label: 'TDS/TCS (₹)',
    width: '100px',
  },
  {
    id: 'totalamount',
    numeric: true,
    disablePadding: false,
    label: 'TOTAL (₹)',
    width: '100px',
    align: 'right',
  },
  {
    id: 'Comments',
    numeric: false,
    disablePadding: false,
    label: 'Remarks / Narration',
    width: '180px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '100px',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, onDelete, setEnableSearch, EnableSearch,setShowActions,showActions, scroll } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const { theme } = useThemes();

  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
            padding: '0px',
            '& .MuiCheckbox-root': {
              padding: '4px',
            },
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        <TableCell
        //  padding="none"
        //  sx={{
        //    padding: "0px",
        //    "& .MuiCheckbox-root": {
        //      padding: "4px",
        //    },
        //  }}
        >
          <Checkbox
            sx={{ color: 'input.border' }}
            disableRipple
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
            size="small"
          />
        </TableCell>
        {headCell.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              minWidth: headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: headCell.id === 'Action' ? 'center' : 'space-between',
                alignItems: 'center',
                flexDirection: headCell.numeric ? 'row-reverse' : '',
                // border: headCell.id === "Action" ? "1px solid black" : "",
                borderRadius: headCell.id === 'Action' ? '3px' : '',
                width: '100%',
                backgroundColor: headCell.id === 'Action' ? 'white' : 'background.tablebg',
                boxShadow: (headCell.id === "Action") && (scroll) ?  "0px 4px 8px rgba(0, 0, 0, 0.6)" : "",
               "&:active": 
                {
                  transform: scroll ? "scale(0.92)":"scale(1)",
                },
              }}

            >
              {headCell.label != 'Actions' ? (
                <>
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                  >
                    <Box sx={{ display: 'flex' }}>
                      <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {orderBy === headCell.id ? (
                          <Box
                            //  component="span"
                            sx={visuallyHidden}
                          >
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                        {/* {headCell.id !== "Action" ? (
                          <SearchIcon
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setEnableSearch((prev) => !prev);
                            }}
                            sx={{ marginLeft: "10px" }}
                            fontSize="small"
                          />
                        ) : null} */}
                      </Box>
                    </Box>
                  </TableSortLabel>
                  {/* <IconButton
                    disableRipple
                    sx={{ margin: "0px 2px", padding: "5px" }}
                  >
                    <FilterAltIcon
                      fontSize="small"
                      sx={{ color: "primary.main" }}
                    />
                  </IconButton> */}
                </>
              ) : (
                <Box 
                  sx={{
                    display:"flex",
                    alignItems:"center",
                    backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
                    }}
                    onClick={(e) => {
                      if(headCell.label === 'Actions'){
                          setShowActions((pre) => !pre)  
                        }
                    }}
                  >
                    {headCell.label}
                      <ArrowCircleRight
                        sx={{
                          transition: 'transform 0.3s ease-in-out',
                          marginLeft: '10px',
                          transform : scroll ? (!showActions ?  'rotate(0deg)' : 'rotate(180deg)') : "(rotate(180deg))",
                          color:scroll ? (!showActions ? 'gray' : '#ee5b2b') : ('#ee5b2b'),
                        }}
                        fontSize="small"
                    /> 
                </Box>
              )}
            </Box>
          </TableCell>
        ))}
        {/* {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null} */}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function PaymentEntries() {
  const dispatch = useDispatch();
  dispatch(display());

  const navigate = useNavigate();

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('voucher');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  // Store latest values in refs to avoid stale closures
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;

  const [deleteSnackBar, setDeleteSnackBar] = useState(false);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [rows, setRows] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [circularOpen, setCircularOpen] = useState(true);
  const [itemData, setItemData] = useState({});
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [ListSelection, setListSelection] = useState('All');
  const [shareOpen, setShareOpen] = useState('');
  const defaultFilterColumns = {
    entrydate: '',
    vouchernumber: '',
    paidfromaccount: '',
    paidtoaccount: '',
    amount: '',
    comments: '',
    transactiontypecd: '',
    total: '',
    tdstcs: '',
    receiptdateto: '',
    receiptdatefrom: '',
    TotalFrom: '',
    TotalTo: '',
    TDSTCSFrom: '',
    TDSTCSTo: '',
    AmountFrom: '',
    AmountTo: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;
  const debouncedSearchRef = useRef(null);
  const handleResetFilterColumns = (status) => {
    if (status === false) {
      setFilterColumns(defaultFilterColumns);
      clearEmailSelection();
      setSelected([]);
    }
  };
  const [emailSendingSelection, setEmailSendingSelection] = useState([]);
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);
  const [showActions,setShowActions] = useState(true)

  const [firstMount, setfirstMount] = useState({ current: true });
  const [metaData, setMetaData] = useState({
    rowCount: 0,
    min_paymentamount: null,
    max_paymentamount: null,
    min_receiptamount: null,
    max_receiptamount: null,
    min_tds_payable_amount: null,
    max_tds_payable_amount: null,
    min_tds_receivable_amount: null,
    max_tds_receivable_amount: null,
    min_totalamount: null,
    max_totalamount: null,
  });

  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
      // Initial data loading is handled by order/orderBy useEffect like in Receipt
    }
  }, []);

  // useEffect(() => {
  //   const controlAndS = (e) => {

  //     if (e.ctrlKey && e.key.toLowerCase() === "s") {
  //       e.preventDefault();
  //       showErrorSnackbar("Nothing to save");
  //     }
  //   };

  //   window.addEventListener('keydown', controlAndS);

  //   return () => {
  //     window.removeEventListener('keydown', controlAndS);
  //   };
  // }, []);

  useSavePrevent();

  const [exportItem, setExportItem] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{ color: 'blue' }} />,
    //   onClick: () => {},
    //   link: '/import-data',
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{ color: '#ffa500' }} />,
      onClick: () => {
        if (rows.length > 0) {
          setExportModalOpen(true);
          setExportItem('PAYMENT');
        } else {
          // setWarningSnakbar(true);
          // setWarningMsg("No data available for export.");
        }
      },
      link: '',
      rollingOutSoon: true
    },
    {
      label: 'Send Selected Payments',
      icon: <MarkEmailUnread />,
      onClick: () => {
        handleBulkEmail();
      },
      link: '',
    },
  ];
  const handleRefetchData = () => {
    getPaymentEntries(true, 0, rowsPerPageRef.current);
  };

  const { openModal, modalProps } = useSendEmailModal();

  // Prefetch last used account data for payment transactions
  const { usePrefetch } = paymentApi;
  const prefetchLastUsedAccount = usePrefetch('getLastUsedBankOrCashAccount');

  const handleBulkEmail = () => {
    if (Freeze === 1) {
      return handleFreeze();
    }
    if (emailSendingSelection.length > 0) {
      const nonPartyAccounts = emailSendingSelection.filter((item) => !item.recipient);
      if (nonPartyAccounts.length > 0) {
        showWarningSnackbar('Selected accounts contain non-party accounts. Only customer/supplier accounts can receive emails.');
        return;
      }
      openModal('payment', emailSendingSelection, handleRefetchData);
    } else {
      showWarningSnackbar("No Receipt's selected. Please select at least one Receipt's to send the email.");
    }
  };

  // Function to explicitly clear email selection
  const clearEmailSelection = () => {
    setEmailSendingSelection([]);
    setIndividualEmailSelection([]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    console.log('handleSelectAllClick called:', event.target.checked, 'rows.length:', rows.length);
    if (event.target.checked && rows.length) {
      const newSelected = [];
      const selectedRows = [];
      rows.forEach((row) => {
        newSelected.push(row.transactionid);
        if (row?.paidfrompartyid) {
          selectedRows.push({
            id: Number(row?.transactionid),
            recipient: true,
            recipientId: Number(row?.paidfrompartyid),
            email: row.paidfromemail,
            name: row.paidfrom,
            invoiceNumber: row.vouchernumber,
          });
        }
      });
      console.log('Setting selected:', newSelected);
      console.log('Setting emailSendingSelection:', selectedRows);
      setSelected(newSelected);
      setEmailSendingSelection(selectedRows);
    } else {
      // Clear all selections
      console.log('Clearing all selections');
      setSelected([]);
      setEmailSendingSelection([]);
    }
  };

  const handleClick = (event, name) => {
    console.log('handleClick called for transactionid:', name);
    console.log('Current selected:', selected);
    const selectedIndex = selected.indexOf(name);
    console.log('selectedIndex:', selectedIndex);
    let newSelected = [];
    let newEmailSelection = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
      const selectedRow = rows.find((row) => row.transactionid === name);
      if (selectedRow) {
        newEmailSelection = [
          ...emailSendingSelection,
          {
            id: Number(selectedRow.transactionid),
            recipient: selectedRow?.paidfrompartyid ? true : false,
            recipientId: Number(selectedRow.paidfrompartyid),
            email: selectedRow.paidfromemail,
            name: selectedRow.paidfrom,
            invoiceNumber: selectedRow.vouchernumber,
          },
        ];
      }
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newEmailSelection = emailSendingSelection.filter((item) => item.id !== Number(name));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newEmailSelection = emailSendingSelection.filter((item) => item.id !== Number(name));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      newEmailSelection = emailSendingSelection.filter((item) => item.id !== Number(name));
    }
    console.log('New selected:', newSelected);
    console.log('New emailSendingSelection:', newEmailSelection);
    setSelected(newSelected);
    setEmailSendingSelection(newEmailSelection);
  };
  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    console.log(event, newPage);
    if (newPage > page) {
      console.log(newPage);
      if (rows.length !== metaData.rowCount)
        if (rows.length < rowsPerPageRef.current * (newPage + 1)) {
          getPaymentEntries(false, rows.length, Math.abs(rowsPerPageRef.current * (newPage + 1) - rows.length));
        }
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const [limit, setlimit] = useState(rowsPerPageRef.current);
  async function getPaymentEntries(reset, from, to, filterColumn) {
    try {
      // const resDeleted = API.graphql(graphqlOperation(listDeletedPayments, { Type: "Payment" }))
      // setDataLoader(true)
      setCircularOpen(true);
      if (rows.length / rowsPerPageRef.current == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPageRef.current < 1) {
        setlimit(rowsPerPageRef.current - rows.length);
      }
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 1;
      let SearchArray = [{ payment: '' }];
      filterColumn = filterColumn ? filterColumn : filterColumns;

      // Handle AmountFrom and AmountTo together to avoid duplicates
      const amountFrom = filterColumn.AmountFrom || '';
      const amountTo = filterColumn.AmountTo || '';

      if (amountFrom || amountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
        const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { AmountFrom: lowerAmount }, { AmountTo: higherAmount }];
      } else if (amountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountFrom: amountFrom }];
      } else if (amountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountTo: amountTo }];
      }

      // Handle TDSTCSFrom and TDSTCSTo together to avoid duplicates
      const tdsFrom = filterColumn.TDSTCSFrom || '';
      const tdsTo = filterColumn.TDSTCSTo || '';

      if (tdsFrom || tdsTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerTds = Number(tdsFrom < tdsTo ? tdsFrom : tdsTo);
        const higherTds = Number(tdsFrom < tdsTo ? tdsTo : tdsFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { TDSTCSFrom: lowerTds }, { TDSTCSTo: higherTds }];
      } else if (tdsFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { TDSTCSFrom: tdsFrom }];
      } else if (tdsTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { TDSTCSTo: tdsTo }];
      }

      // Handle TotalFrom and TotalTo together to avoid duplicates
      const totalFrom = filterColumn.TotalFrom || '';
      const totalTo = filterColumn.TotalTo || '';

      if (totalFrom || totalTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerTotal = Number(totalFrom < totalTo ? totalFrom : totalTo);
        const higherTotal = Number(totalFrom < totalTo ? totalTo : totalFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { TotalFrom: lowerTotal }, { TotalTo: higherTotal }];
      } else if (totalFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { TotalFrom: totalFrom }];
      } else if (totalTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { TotalTo: totalTo }];
      }

      Object.keys(filterColumn).map((key) => {
        // Skip amount range fields as they are handled above
        if (
          key === 'AmountFrom' ||
          key === 'AmountTo' ||
          key === 'TDSTCSFrom' ||
          key === 'TDSTCSTo' ||
          key === 'TotalFrom' ||
          key === 'TotalTo'
        ) {
          return;
        }

        if (filterColumn[key]?.toString()?.length > 0) {
          searchMode = 1;
          SearchArray = [...SearchArray, { [key]: filterColumn[key] }];
        }
      });
      // CancelFlag is now handled directly in the dropdown onChange handler
      // No need for switch statement here
      const resActive = await API.graphql(
        graphqlOperation(listTransactionMasterv2, {
          transactiontypecd: 'payment',
          rowfrom: from,
          limitno: to,
          columnname: orderBy.toLocaleLowerCase(),
          ordertype: order.toLocaleLowerCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );

      const resCount = await API.graphql(
        graphqlOperation(listTransactionMasterCount, {
          transactiontypecd: 'payment',
          rowfrom: from,
          limitno: to,
          columnname: orderBy.toLocaleLowerCase(),
          ordertype: order.toLocaleLowerCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );

      Promise.all([resActive, resCount])
        .then((response) => {
          let res = response[0];

          if (response?.[1].data) {
            const {
              transactionmasterlistcount: rowCount,
              min_paymentamount,
              max_paymentamount,
              min_receiptamount,
              max_receiptamount,
              min_tds_payable_amount,
              max_tds_payable_amount,
              min_tds_receivable_amount,
              max_tds_receivable_amount,
              min_totalamount,
              max_totalamount,
            } = response[1].data.listTransactionMasterCount?.[0];

            setMetaData({
              rowCount: rowCount || 0,
              min_paymentamount,
              max_paymentamount,
              min_receiptamount,
              max_receiptamount,
              min_tds_payable_amount,
              max_tds_payable_amount,
              min_tds_receivable_amount,
              max_tds_receivable_amount,
              min_totalamount,
              max_totalamount,
            });
          }
          // let dres = response[0]
          // console.log(res, dres)
          let arr = [];
          let arrD = []; //deleted list
          arr = res.data.listTransactionMasterv2.filter((elem) => elem.statuscode == '');
          let cArr = [...arr, ...arrD];
          if (reset) {
            setRows((prev) => [...cArr]);
            setCircularOpen(false);
          } else {
            setRows((prev) => [...prev, ...cArr]);
            setCircularOpen(false);
          }
        })
        .finally(() => {
          setlimit(0);
          setBackdropOpen(false);
          setCircularOpen(false);
        });
    } catch (error) {
      setlimit(0);
      console.log('error', error);
      setBackdropOpen(false);
      setCircularOpen(false);
    }
  }
  let search = (obj) => {
    getPaymentEntries(true, 0, rowsPerPageRef.current, obj);
  };

  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = createDebouncedCallback(
      (obj) => {
        // Always use current values from refs
        const currentFilterColumns = filterColumnsRef.current;
        const currentRowsPerPage = rowsPerPageRef.current;

        // Check if there are any non-empty filter values
        const hasFilters = Object.values(currentFilterColumns).some((value) => value && value.toString().trim().length > 0);

        if (hasFilters) {
          getPaymentEntries(true, 0, currentRowsPerPage, currentFilterColumns);
        } else {
          getPaymentEntries(true, 0, currentRowsPerPage);
        }
      },
      500,
      false
    );
  }

  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);
  useEffect(() => {
    if (firstMount.current === false) {
      // Use the debounced search which will check current filterColumns
      filterSearch();
    }
    return () => {};
  }, [filterColumns, filterSearch]);

  const filterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumnsRef.current };
    if (name == 'Amount') {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    } else if (name == 'TDSTCS') {
      obj['TDSTCSFrom'] = query[0];
      obj['TDSTCSTo'] = query[1];
    } else if (name == 'Total') {
      obj['TotalFrom'] = query[0];
      obj['TotalTo'] = query[1];
    } else {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    }

    setFilterColumns(obj);
  };

  // useEffect(() => {
  //   if (localStorage.getItem("saveEvent") === "true") {
  //     setsuccessSnakbar(true);
  //     // setSnakbarTex("Payment Entry Added!");
  //     localStorage.setItem("saveEvent", false);
  //   }
  // }, []);
  // useEffect(() => {
  //   if (localStorage.getItem("updateEvent") === "true") {
  //     setUpdateSnakbar(true);
  //     // setUpdateSnakbarTex("Payment Entry Updated!");
  //     localStorage.setItem("updateEvent", false);
  //   }
  // }, []);

  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();

  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });
  const cancel = async (id, type, voucherNo) => {
    return new Promise(async (resolve, reject) => {
      try {
        let data = {
          TransactionID: id,
          CancelFlag: 1,
          CancelRemark: state.reason,
          TransactionTypeCD: type,
          VoucherNumber: voucherNo,
        };
        let response = await API.graphql(
          graphqlOperation(cancelTransactionMaster, {
            updateTransactionMasterInput: data,
          })
        );
        let tempRows = JSON.parse(JSON.stringify(rows));
        let temp = tempRows.map((elem) => {
          if (elem.VoucherNumber == voucherNo) {
            elem.CancelFlag = 1;
            return elem;
          } else {
            return elem;
          }
        });
        setRows(temp);
        showSuccessSnackbar('Payment Entry Cancelled');
        // getPaymentEntries();
      } catch (error) {
        showErrorSnackbar('Something Went Wrong !');
        console.log(error);
      } finally {
        resolve();
      }
    });
  };

  const [EnableSearch, setEnableSearch] = useState(false);

  const DateRangeRef = useRef(null);
  const openDateRange = () => {
    console.log(DateRangeRef);
    setEnableSearch(true);
    DateRangeRef?.current?.openDatePicker();
  };
  useEffect(() => {
    console.log(order, orderBy);
    setRows([]);
    setPage(0);
    clearEmailSelection();
    setSelected([]);
    getPaymentEntries(true, 0, rowsPerPageRef.current);
    return () => {};
  }, [order, orderBy]);
  useEffect(() => {
    console.log(rowsPerPage, rows.length);
    if (firstMount.current === false) {
      if (rowsPerPageRef.current > rows.length) {
        console.log(rowsPerPage, rows.length);
        getPaymentEntries(true, 0, rowsPerPageRef.current);
      } else {
        console.log(rowsPerPage, rows.length);
      }
    }
    return () => {};
  }, [rowsPerPage]);

     const paymentTableRef = useRef(null)

     const [scroll,setScroll] = useState(false)
       useEffect(() => {
       if (rows.length > 0 && !circularOpen) {
         const width = paymentTableRef.current?.offsetWidth;
         const screenWidth = window.innerWidth;
         if (width < screenWidth) {
          setScroll(false)
         } else {
           setScroll(true);
         }
       }
     }, [rows, circularOpen]);

  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(0);
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(0);

  const [accountID, setAccountID] = useState('');

  const userPrefrenceandReducer = useSelector((state) => state.userPrefrenceandReducer);
  console.log(userPrefrenceandReducer);
  useEffect(() => {
    console.log(userPrefrenceandReducer?.financialYear?.StartDate);
    if (userPrefrenceandReducer?.financialYear) {
      setLedgerModalStartDate(userPrefrenceandReducer?.financialYear?.StartDate);
      setLedgerModalEndDate(userPrefrenceandReducer?.financialYear?.EndDate);
    }
  }, [userPrefrenceandReducer]);

  const device = useMediaQuery(theme.breakpoints.down('sm'));
  const [rolling, setRolling] = useState(false);
  const tableRef = useRef(null);

  return (
    <Box className="noTableCellBorder">
      <Snackbar className="snackBar-delete" open={deleteSnackBar} autoHideDuration={6000} onClose={() => console.log('handleclose')}>
        <Box
          sx={{
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            display: 'flex',
            flexDirection: 'row',
            padding: '7px 20px',
            borderRadius: '7px',
            backgroundColor: '#fff',
            transition: 'all 2s ease-in-out',
            '&:hover': {
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
            },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ color: 'rgb(60 60 60)', fontWeight: 'bold' }}>Delete selected rows ? </Typography>
            <Box onClick={() => setDeleteSnackBar(false)} sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box
                sx={{
                  flex: 1,
                  backgroundColor: '#b1d1f97d',
                  margin: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                  borderRadius: '7px',
                }}
              >
                <Typography sx={{ color: '#6096d9' }}>No</Typography>
              </Box>
              <Box
                onClick={() => setDeleteSelectedModal(true)}
                sx={{
                  flex: 1,
                  backgroundColor: '#fbc7c78c',
                  margin: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                  borderRadius: '7px',
                }}
              >
                <Typography sx={{ color: '#d32f2f' }}>Yes</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Snackbar>

      <ConfirmDeleteModal open={deleteModalStatus} storage="paymententries" itemId={deleteId} setOpen={setDeleteModalStatus} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
        }}
      >
        <LinkList
          list="All Payment Entries"
          link="/addpaymententries"
          add="Add Payment"
          onClick={() => prefetchLastUsedAccount({ transactiontypecd: 'payment' })}
        />

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'paymentSearch'}
            onClick={handleResetFilterColumns}
          />

          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
              },
            }}
          >
            <Box
              sx={{
                display: {
                  xs: 'none',
                  sm: 'flex',
                  md: 'flex',
                  lg: 'flex',
                  xl: 'flex',
                  gap: '10px',
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: '13px',
                  color: 'white',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Total : {metaData.rowCount} Item{metaData.rowCount !== 1 && 's'}{' '}
                {selected.length != 0 ? `(Selected: ${selected.length}/${metaData.rowCount})` : ''}
              </Typography>
              <DropDownForListing
                name={'ser'}
                value={ListSelection}
                onChange={(e) => {
                  let value = e.target.value;
                  setListSelection(value);
                  setPage(0);
                  // Directly trigger search with CancelFlag
                  const currentFilterColumns = { ...filterColumnsRef.current };
                  currentFilterColumns.CancelFlag = value !== 'All' ? (value === 'Active' ? 0 : 1) : '';
                  getPaymentEntries(true, 0, rowsPerPageRef.current, currentFilterColumns);
                }}
              />
              <PeriodDropDown
                custom={openDateRange}
                onChange={(start, end) => {
                  setFilterColumns((prev) => ({
                    ...prev,
                    receiptdatefrom: start,
                    receiptdateto: end,
                  }));
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '5px',
                  p: 1,
                  cursor: 'pointer',
                  '&:hover': {
                    borderColor: '#ccc',
                    backgroundColor: theme.palette.input.border || '#f5f5f5',
                  },
                }}
                onClick={handleClickBox} // Toggle the popover on box click
              >
                <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <Box sx={{ p: 1, minWidth: '200px' }}>
                    {
                      options.map((option,index) => 
                        option.rollingOutSoon ? 
                        (
                          <Typography
                            key={index}
                            onClick={() => {
                              handleClose();
                            }}
                            sx={{
                              padding: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              // '&:hover': {
                              //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                              // },
                            }}
                          >
                        <Tooltip 
                          title={<RollingSoon />}
                          placement="right"
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                padding: 0,
                              } 
                            }
                          }}
                        >      
                          <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {option.icon}
                              <span style={{ marginLeft: '8px', opacity: 0.5 }}>
                                {option.label}
                              </span>
                          </Box>
                        </Tooltip> 
                          </Typography>
                        ): 
                        (<Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                            <Typography
                              key={index}
                              onClick={() => {
                                handleClose();
                                option.onClick();
                              }}
                              sx={{
                                cursor: 'pointer',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                // '&:hover': {
                                //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                                // },
                              }}
                            >
                              {option.icon}
                              <span style={{ marginLeft: '8px' }}>{option.label}</span>
                            </Typography>
                        </Link>)
                      )
                    }
                  </Box>
                </Popover>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <>
        <Box
          sx={{
            // boxShadow: "inset 0 0 8px #d7d7d73b",
            boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
            // borderBottomRightRadius: "12px",
            // borderBottomLeftRadius: "12px",
            // backgroundColor: theme.palette.bodyGray.secondary,
            borderRadius: '12px',
            padding: {
              // xs: "8px 12px",
            },
            '.css-1mxz8qt-MuiPaper-root': {
              boxShadow: 'none',
            },
            '.MuiTableCell-root': {
              padding: '1px 10px',
              fontSize: '13px',
            },
            '.MuiTableCell-head': {
              // color: "#808080",
              backgroundColor: 'background.tablebg',
              padding: '5px 10px',
              borderBottom: '0px',
              fontWeight: 'bold',
            },
            // ".MuiTableCell-head:first-of-type": {
            //   borderTopLeftRadius: "6px",
            //   borderBottomLeftRadius: "6px",
            // },
            '.MuiTableCell-head:last-child': {
              borderTopRightRadius: '6px',
              borderBottomRightRadius: '6px',
            },
          }}
        >
          {rows.length <= 0 && device ? (
            <>
              <Typography
                sx={{
                  height: '70vh',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                No data found
              </Typography>
            </>
          ) : (
            <>
              <Box sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
                <TableContainer ref={tableRef} className="custom-scrollbar" sx={{ height: 'calc( 100vh - 230px )' }}>
                  <Table
                    stickyHeader
                    aria-label="sticky table"
                    sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={dense ? 'small' : 'medium'}
                  >
                    <EnhancedTableHead
                      EnableSearch={EnableSearch}
                      setEnableSearch={setEnableSearch}
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={metaData.rowCount}
                      onDelete={() => setDeleteSelectedModal(true)}
                      setShowActions = {setShowActions}
                      showActions = {showActions}
                      scroll = {scroll}
                    />
                    {/* Debug info */}
                    {console.log('EnhancedTableHead props:', {
                      numSelected: selected.length,
                      rowCount: metaData.rowCount,
                      selected: selected,
                      metaData: metaData,
                    })}
                    <TableBody ref= {paymentTableRef}>
                      <TableRow
                        sx={{
                          '.MuiTableCell-root': {
                            padding: '8px 15px',
                          },
                          '.css-wrnu0i-MuiInputBase-root': {
                            fontSize: '13px',
                          },
                          '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                            padding: '2px 4px',
                          },
                          '.css-1gqfvv-MuiPaper-root': {
                            boxShadow: 'none',
                            borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                            borderRadius: '0px',
                          },
                          // visibility: !EnableSearch ? "collapse" : "visible",
                          display: !EnableSearch ? 'none' : 'content',
                        }}
                      >
                        <TableCell id="paymentSearch"></TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            {/* <InputBase
                        name="supplierInvoiceDate"
                        value={filterColumns.supplierInvoiceDate}
                        onChange={(e) =>
                          handleFilterBySearch(e, "SupplierInvoiceDate")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      /> */}
                            <DateRangeRsuite
                              ref={DateRangeRef}
                              containerRef={tableRef}
                              value={[
                                filterColumns.receiptdatefrom ? filterColumns.receiptdatefrom : null,
                                filterColumns.receiptdateto ? filterColumns.receiptdateto : null,
                              ]}
                              onChange={(e) => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  receiptdatefrom: e.from ? e.from : '',
                                  receiptdateto: e.to ? e.to : '',
                                }));
                              }}
                              className="hide-input-outline hide-input-border"
                            />
                            {/* <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.receiptdatefrom !== '' || filterColumns.receiptdateto != '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      receiptdatefrom: '',
                                      receiptdateto: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton> */}
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="vouchernumber"
                              value={filterColumns.vouchernumber}
                              onChange={(e) => filterBySearch(e, 'vouchernumber')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ padding: '0px' }}>
                              {filterColumns.vouchernumber !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      vouchernumber: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="paidtoaccount"
                              value={filterColumns.paidtoaccount}
                              onChange={(e) => filterBySearch(e, 'paidtoaccount')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ padding: '0px' }}>
                              {filterColumns.paidtoaccount !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      paidtoaccount: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="paidfromaccount"
                              value={filterColumns.paidfromaccount}
                              onChange={(e) => filterBySearch(e, 'paidfromaccount')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ padding: '0px' }}>
                              {filterColumns.paidfromaccount !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      paidfromaccount: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>

                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                              border: 'none',
                            }}
                          >
                            <Autocomplete
                              id={''}
                              disableClearable
                              options={['Cash', 'Bank']}
                              isOptionEqualToValue={(option, value) => option == value}
                              clearIcon={filterColumns.transactiontypecd !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                              name="transactiontypecd"
                              value={filterColumns.transactiontypecd}
                              onChange={(e, newvalue) => filterBySearch({ target: { value: newvalue } }, 'transactiontypecd')}
                              size="small"
                              sx={{ height: '32px' }}
                              renderOption={(props, option) => (
                                <>
                                  <MenuItem {...props} key={option} value={option}>
                                    <ListItemText primary={option} />
                                  </MenuItem>
                                </>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  sx={{
                                    minWidth: '100px',
                                    border: 'none', // Ensure border is removed
                                    '& .MuiInput-underline:before': {
                                      borderBottom: 'none', // Remove underline in standard variant
                                    },
                                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                      borderBottom: 'none', // Remove hover effect
                                    },
                                    '& .MuiInput-underline:after': {
                                      borderBottom: 'none', // Remove underline for focused state
                                    },
                                    '& fieldset': { border: 'none' },
                                  }}
                                  placeholder={'Search'}
                                  variant="standard"
                                  InputLabelProps={{
                                    shrink: true,
                                    style: { color: 'black' },
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.transactiontypecd !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      transactiontypecd: '',
                                    }));
                                    // setFilteredList(invoiceRows);
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>

                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              width: '100%',
                            }}
                          >
                            <Stack direction={'row'} height={'32px'} gap="5px">
                              <MoneyTextFieldRange
                                value={[filterColumns.AmountFrom, filterColumns.AmountTo]}
                                onChange={(e) => {
                                  filterBySearch(e, 'Amount', e);
                                }}
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        AmountFrom: '',
                                        AmountTo: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Stack>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',

                              width: '100%',
                            }}
                          >
                            <Stack direction={'row'} height={'32px'} gap="5px">
                              <MoneyTextFieldRange
                                value={[filterColumns.TDSTCSFrom, filterColumns.TDSTCSTo]}
                                onChange={(e) => {
                                  filterBySearch(e, 'TDSTCS', e);
                                }}
                              />

                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.TDSTCSFrom !== '' || filterColumns.TDSTCSTo !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        TDSTCSFrom: '',
                                        TDSTCSTo: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Stack>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              width: '100%',
                            }}
                          >
                            <Stack direction={'row'} height={'32px'} gap="5px">
                              <MoneyTextFieldRange
                                value={[filterColumns.TotalFrom, filterColumns.TotalTo]}
                                onChange={(e) => {
                                  filterBySearch(e, 'Total', e);
                                }}
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.TotalFrom !== '' || filterColumns.TotalTo !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        TotalFrom: '',
                                        TotalTo: '',
                                      }));
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Stack>
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="comments"
                              value={filterColumns.comments}
                              onChange={(e) => filterBySearch(e, 'comments')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ padding: '0px' }}>
                              {filterColumns.comments !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      comments: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Paper>
                        </TableCell>
                        <TableCell className="actionBackGround" sx={{ backgroundColor: 'transparent !important' }}></TableCell>
                      </TableRow>
                      {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                            rows.slice().sort(getComparator(order, orderBy)) */}
                      {rows.length > 0 ? (
                        rows
                          .slice(page * rowsPerPageRef.current, page * rowsPerPageRef.current + rowsPerPageRef.current)
                          .map((row, index) => {
                            const isItemSelected = isSelected(row?.transactionid);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            let accounts = row.paidto?.split(',');
                            row.paidto = accounts?.[0] ?? '';
                            row.amt = row.paymentamount;
                            row.tdstcs = row.tds_payable_amount;
                            row.mode = row.transactiontypecd === 'CashPayment' ? 'Cash' : 'Bank';

                            return (
                              <TableRow
                                hover
                                className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                // onClick={(event) => handleClick(event, row.paymentDate)}
                                onClick={(event) => {
                                  // dispatch(
                                  //   updateViewTitle(
                                  //     row.cancelflag == 1
                                  //       ? {
                                  //         type: "Cancelled",
                                  //         name: row.vouchernumber,
                                  //       }
                                  //       : { type: "", name: row.vouchernumber }
                                  //   )
                                  // );
                                  dispatch(updateTitle(row.vouchernumber));
                                  navigate('/viewpaymententries', {
                                    state: {
                                      id: row.transactionid,
                                      view: true,
                                      pdflink: row?.pdflink,
                                    },
                                  });
                                }}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={index}
                                selected={isItemSelected}
                                style={{ cursor: 'pointer' }}
                                sx={{
                                  '.MuiTableCell-root': {
                                    backgroundColor: 'transparent ',
                                    borderBottom: 'none',
                                  },
                                }}
                              >
                                <TableCell
                                  title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                  padding="none"
                                  sx={{
                                    padding: '0px',
                                    '& .MuiCheckbox-root': {
                                      padding: '4px',
                                    },
                                  }}
                                >
                                  <Checkbox
                                    disableRipple
                                    color="primary"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleClick(event, row.transactionid);
                                    }}
                                    checked={isItemSelected}
                                    inputProps={{
                                      'aria-labelledby': labelId,
                                    }}
                                    size="small"
                                  />
                                </TableCell>
                                <TableCell
                                  title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                  // component="th"
                                  id={labelId}
                                  scope="row"
                                  // padding="none"
                                >
                                  {formatUnixTimestamp(row.entrydate)}
                                  {/* {new Date(
                                row.EntryDate * 1000
                              ).toLocaleDateString()} */}
                                </TableCell>
                                <TableCell align="left" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                  {/* <Typography
                                    // underline="hover"
                                    // className="link-thex"
                                    sx={{ cursor: "pointer", fontSize: "13px" }}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      dispatch(
                                        updateViewTitle(
                                          row.cancelflag == 1
                                            ? {
                                              type: "Cancelled",
                                              name: row.vouchernumber,
                                            }
                                            : {
                                              type: "",
                                              name: row.vouchernumber,
                                            }
                                        )
                                      );
                                      dispatch(updateTitle(row.vouchernumber));
                                      navigate("/viewpaymententries", {
                                        state: {
                                          id: row.transactionid,
                                          view: true,
                                          pdflink: row?.pdflink
                                        },
                                      });
                                    }}
                                  >
                                  </Typography> */}
                                  <a
                                    className="myLink"
                                    href={`/viewpaymententries/${row.vouchernumber}?transaction=${row.transactionid}`}
                                    rel="noreferrer"
                                    target="_blank"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  >
                                    {row.vouchernumber}
                                  </a>
                                </TableCell>
                                <TableCell align="left" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                  <a
                                    className="myLink"
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      console.log(row);
                                      // setBackdropOpen(true);
                                      // setAccountName(row?.PaidTo);
                                      setAccountID(row?.paidtoaccountid?.split(',')?.[0]);
                                      // getModalData(row?.PaidToAccountID?.split(",")?.[0]);
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      // color: row.Restrictedflag === 1 ? theme.palette.primary.main : "#057864"
                                    }}
                                  >
                                    {row.paidto}
                                  </a>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                  sx={{
                                    maxWidth: '100px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  <Tooltip title={row.paidfrom} placement="right">
                                    <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      <a
                                        className="myLink"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          console.log(row);
                                          // setBackdropOpen(true);
                                          // setAccountName(row?.PaidFrom);
                                          setAccountID(row?.paidfromaccountid);
                                          // getModalData(row?.PaidFromAccountID);
                                        }}
                                        style={{
                                          cursor: 'pointer',
                                          // color: row.Restrictedflag === 1 ? theme.palette.primary.main : "#057864"
                                        }}
                                      >
                                        {row.paidfrom}
                                      </a>
                                    </span>
                                  </Tooltip>
                                </TableCell>

                                <TableCell align="left" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                  {row.mode}
                                </TableCell>
                                <TableCell align="right" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                  {MoneyFormatv3(row.amt)}
                                </TableCell>
                                <TableCell align="right" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                  {MoneyFormatv3(row.tdstcs)}
                                </TableCell>
                                <TableCell align="right" title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                  {MoneyFormatv3(Number(row.totalamount))}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                  sx={{
                                    maxWidth: '180px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  <Tooltip title={row?.comments?.replace('**', '\n')} placement="left">
                                    <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {row?.comments?.replace('**', '\n')}
                                    </span>
                                  </Tooltip>
                                </TableCell>
                                <TableCell className="actionBackGround" align="center" sx={{position :!showActions ? 'relative' : 'sticky'}}>
                                  <Box className="actionCellStyle">
                                    <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          checkandopenpdf(row.pdflink);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#c5d6dc',
                                          border: 'solid 1px black',
                                        }}
                                      >
                                        <img src={pdfImage} height={10} alt="Download" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title={'Print'} placement="top" disableInteractive arrow>
                                      <IconButton
                                        disableRipple
                                        onClick={(event) => {
                                          // Delete(event, row.TransactionID, index);
                                          event.preventDefault();
                                          event.stopPropagation();
                                          fetchAndPrintPDF(row.pdflink);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#c5d6dc',
                                          border: 'solid 1px black',
                                        }}
                                      >
                                        <LocalPrintshop
                                          sx={{
                                            fontSize: '10px',
                                            color: '#36454f',
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    {/* {row.cancelflag !== 1 && ( */}
                                    <Tooltip
                                      title={row.cancelflag === 1 ? 'cannot Edit' : 'Edit'}
                                      placement="left"
                                      disableInteractive
                                      arrow
                                    >
                                      <IconButton
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          if (Freeze == 1) {
                                            return handleFreeze();
                                          }
                                          if (row.cancelflag === 1) {
                                            return;
                                          }
                                          dispatch(updateTitle(row.vouchernumber));
                                          localStorage.removeItem('PaymentTransactionID');
                                          localStorage.removeItem('PaymentViewMode');
                                          // Prefetch last used account data before navigation
                                          prefetchLastUsedAccount({ transactiontypecd: 'payment' });
                                          navigate('/editpaymententries', {
                                            state: {
                                              id: row.transactionid,
                                              pdflink: row.pdflink,
                                              // view: true,
                                            },
                                          });
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#D0EFFF',
                                          border: 'solid 1px black',
                                        }}
                                      >
                                        {row.cancelflag === 1 ? (
                                          <EditOff sx={{ fontSize: '10px', color: '#6096d9' }} />
                                        ) : (
                                          <EditIcon
                                            sx={{
                                              fontSize: '10px',
                                              color: '#6096d9',
                                            }}
                                          />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                    {/* )} */}
                                    <Tooltip title={'Share'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          // For individual Share, use separate state
                                          // that doesn't interfere with bulk selection
                                          setIndividualEmailSelection([
                                            {
                                              id: Number(row.transactionid),
                                              recipientId: Number(row?.paidfrompartyid),
                                              email: row?.paidfromemail,
                                              name: row.paidfrom,
                                              invoiceNumber: row.vouchernumber,
                                            },
                                          ]);
                                          setShareOpen(row.pdflink);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#E8F5E9',
                                          border: 'solid 1px black',
                                          // backgroundColor: '#b1d1f97d'
                                        }}
                                      >
                                        <Share
                                          sx={{
                                            fontSize: '10px',
                                            color: '#388E3C',
                                            // color: '#6096d9'
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    {/* {row.CancelFlag !== 1 && (
                                  <Tooltip
                                    title={"cancel"}
                                    placement="right"
                                    disableInteractive
                                    arrow
                                  >
                                    <IconButton
                                      onClick={(event) => {
                                        Cancel(event, row, index);
                                      }}
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "5px",
                                        backgroundColor: "#b1d1f97d",
                                      }}
                                    >
                                      <Close
                                        sx={{ fontSize: "15px", color: "#6096d9" }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )} */}
                                    {/* <ThreeDot
                                  onEdit={
                                    row.ExpiredTimeStamp != 0 ||
                                      row.CancelFlag == 1
                                      ? null
                                      : (event) => {
                                        event.stopPropagation();
                                        dispatch(
                                          updateTitle(row.VoucherNumber)
                                        );
                                        localStorage.removeItem(
                                          "PaymentTransactionID"
                                        );
                                        localStorage.removeItem(
                                          "PaymentViewMode"
                                        );

                                        navigate("/editpaymententries", {
                                          state: { id: row.TransactionID },
                                        });
                                      }
                                  }
                                  onDelete={
                                    row.ExpiredTimeStamp === 0
                                      ? (event) => {
                                        Delete(event, row.TransactionID, index);
                                      }
                                      : ""
                                  }
                                  onView={(event) => {
                                    event.stopPropagation();
                                    dispatch(updateTitle(row.VoucherNumber));
                                    navigate("/viewpaymententries", {
                                      state: {
                                        id: row.TransactionID,
                                        view: true,
                                      },
                                    });
                                  }}
                                  onCancel={
                                    row.CancelFlag == 1
                                      ? null
                                      : (event) => {
                                        Cancel(event, row, index);
                                      }
                                  }
                                /> */}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })
                      ) : circularOpen == false ? (
                        <TableRow>
                          <TableCell height={400} align="center" colSpan={8} sx={{ border: 'none' }}>
                            No Data Found
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                      {circularOpen == true &&
                        rowsPerPage > 0 &&
                        Array.from({ length: rowsPerPage }, (_, index) => (
                          <TableRow key={index}>
                            <TableCell colSpan={12}>
                              <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {rows.length > 0 && (
                  <TablePagination
                    // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                    rowsPerPageOptions={defaultRowsPerPageOptions}
                    component="div"
                    count={metaData.rowCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            </>
          )}
        </Box>
      </>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DeletePaymentEntry open={deleteItemModal} setOpen={setDeleteItemModal} itemData={itemData} rows={rows} setRows={setRows} />
      {/* <ExportData
        setOpen={setExportModalOpen}
        open={exportModalOpen}
        item={exportItem}
      /> */}
      {shareOpen ? (
        <ShareModal
          open={shareOpen}
          setOpen={setShareOpen}
          emailData={{
            selectedRow: individualEmailSelection,
            type: 'payment',
          }}
          text={'Payment'}
        />
      ) : null}
      <DeleteSelectedPaymentEntry
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        rows={rows}
        setRows={setRows}
        itemsData={selected}
      />

      <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />

      {/* <DeleteSelectedEntry open={deleteSelectedModal} setOpen={setDeleteSelectedModal} rows={rows} setRows={setRows} setDeleteSuccessSnakbar={setDeleteSuccessSnakbar} itemsData={selected} /> */}
      {WarningModal}

      <SendEmailModalWrapper {...modalProps} />
    </Box>
  );
}

export default PaymentEntries;
